
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("iodyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $d634fbed7e34df51$var$_jquery = $d634fbed7e34df51$var$_interopRequireDefault((parcelRequire("4kMWr")));

var $d634fbed7e34df51$var$_swiper = $d634fbed7e34df51$var$_interopRequireDefault((parcelRequire("htp1E")));

var $bTZx8 = parcelRequire("bTZx8");
function $d634fbed7e34df51$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $d634fbed7e34df51$var$init = module.exports.init = function init() {
    (0, $d634fbed7e34df51$var$_jquery["default"])(".ctype-ce_numbers_info_teaserbox").each(function() {
        var currentIndex = 0;
        var $this = (0, $d634fbed7e34df51$var$_jquery["default"])(this);
        var cID = $this.attr("id");
        var id = $this.find(".swiper-nit-slider").attr("id");
        var $thumbBtnPrev = $this.find(".thumbnail-swiper-prev");
        var $thumbBtnNext = $this.find(".thumbnail-swiper-next");
        var $thumbnails = $this.find(".thumbnail-container button.thumbnail");
        var nitSlider = new $d634fbed7e34df51$var$_swiper["default"]("#" + id, {
            modules: [
                $bTZx8.Navigation,
                $bTZx8.A11y,
                $bTZx8.Keyboard,
                $bTZx8.EffectFade,
                $bTZx8.Pagination
            ],
            effect: "fade",
            navigation: {
                nextEl: "#" + cID + " .swiper-nit-slider-next",
                prevEl: "#" + cID + " .swiper-nit-slider-prev"
            },
            pagination: {
                el: "#" + cID + " .swiper-pagination",
                type: "custom",
                renderCustom: function renderCustom(swiper, current, total) {
                    return "" + current + " von " + total + "";
                }
            },
            keyboard: {
                enabled: true
            },
            a11y: {
                enabled: true
            },
            fadeEffect: {
                crossFade: true
            },
            on: {
                afterInit: function afterInit() {
                    (0, $d634fbed7e34df51$var$_jquery["default"])("#" + cID).addClass("slider-init");
                }
            }
        });
        $this.find("button.thumbnail").on("click", function(e) {
            var index = (0, $d634fbed7e34df51$var$_jquery["default"])(this).data("index");
            (0, $d634fbed7e34df51$var$_jquery["default"])(this).parent().find("button").removeClass("active");
            (0, $d634fbed7e34df51$var$_jquery["default"])(this).addClass("active");
            nitSlider.slideTo(parseInt(index));
            currentIndex = index;
            updateSlider(currentIndex);
        });
        $thumbBtnPrev.css("opacity", "50%");
        var updateSlider = function updateSlider(index) {
            $thumbnails.removeClass("active");
            $thumbnails.eq(index).addClass("active");
            nitSlider.slideTo(index);
            if (currentIndex === 0) {
                $thumbBtnPrev.css("opacity", "50%");
                $thumbBtnNext.css("opacity", "");
            } else if (currentIndex === $thumbnails.length - 1) {
                $thumbBtnNext.css("opacity", "50%");
                $thumbBtnPrev.css("opacity", "");
            } else {
                $thumbBtnPrev.css("opacity", "");
                $thumbBtnNext.css("opacity", "");
            }
        };
        $thumbBtnPrev.on("click", function() {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider(currentIndex);
            }
        });
        $thumbBtnNext.on("click", function() {
            if (currentIndex < $thumbnails.length - 1) {
                currentIndex++;
                updateSlider(currentIndex);
            }
        });
    });
};

});

parcelRegister("7bv9Y", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53b1bb303d082687$export$581ff339ea0ba762; });

var $cgqFP = parcelRequire("cgqFP");
function $53b1bb303d082687$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $cgqFP._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("cgqFP", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $8edbab78a07e92a4$export$1e71eb4bef00f6b0; });
function $8edbab78a07e92a4$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("evINV", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a906b7200f9116bb$export$4fa2f4023c9cbda5; });
function $a906b7200f9116bb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a906b7200f9116bb$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $a906b7200f9116bb$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});


//# sourceMappingURL=nit.module.7ee4365b.js.map
